import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {AlertService, AuthenticationService, UserService} from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { ImapConfigurationService } from '@app/_components/imap-configuration/imap-configuration.service';
import { ImapConfiguration } from '@app/_components/imap-configuration/imap-configuration';
import { User } from '@app/_models';
import { Subscription } from 'rxjs';
import {first} from 'rxjs/operators';

@Component({
    selector: 'app-imap-configuration',
    templateUrl: './imap-configuration.component.html',
    styleUrls: ['./imap-configuration.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ImapConfigurationComponent implements OnInit {

	accesstypes: any;
	protocol: any;
	gmailAuthTypes: any;
	currentUser: User;
	gmailTestResult: any = null;
	gmailTestLoading = false;
	syncGmailMsgId: string = '';
	syncGmailLoading = false;
	syncGmailResult: any = null;
	currentUserSubscription: Subscription;
  selectedUser: any;
  users: any[] = [];
  userId: any;
	constructor(
		private primengConfig: PrimeNGConfig,
		private imapConfigurationService: ImapConfigurationService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private authenticationService: AuthenticationService,
    private userService: UserService,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.imapConfiguration = data.imapConfiguration,
			this.accesstypes = imapConfigurationService.accesstypes;
		this.protocol = imapConfigurationService.protocol;
		this.gmailAuthTypes = imapConfigurationService.gmailAuthTypes;
		this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
			this.currentUser = user;
			console.log(this.currentUser.userId);
		});
	}

	@Input() imapConfiguration: ImapConfiguration;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	imapConfigurationId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;



	validationMessages = {
		'imapConfigurationId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'email': [
			{ type: 'required', message: 'Required' }],
		'password': [
			{ type: 'required', message: 'Required' }],
		'protocol': [
			{ type: 'required', message: 'Required' }],
		'host': [
			{ type: 'required', message: 'Required' }],
		'port': [
			{ type: 'required', message: 'Required' }],
		'lastreaduid': [
      { type: 'required', message: 'Required' }],
		'lastsentreaduid': [
      { type: 'required', message: 'Required' }],
		'msgreadpercall': [
      { type: 'required', message: 'Required' }],
		'msgremainingToBeRead': [
      { type: 'required', message: 'Required' }],
		'userId': [],
		'inboxFolder': [{ type: 'required', message: 'Required' }],
		'sentFolder': [],
		'access': [],
		'active': [],
		'smtpProtocol': [
      { type: 'required', message: 'Required' }],
		'smtpHost': [
      { type: 'required', message: 'Required' }],
		'smtpPort': [
      { type: 'required', message: 'Required' }],
		'smtpSSLPort': [
      { type: 'required', message: 'Required' }],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole imapConfiguration object
		if (this.imapConfiguration) {
			this.imapConfigurationId = this.imapConfiguration.imapConfigurationId;
      if ( this.imapConfiguration.user){
        this.imapConfiguration.user.fullName = this.imapConfiguration?.user?.lastName + ' ' + this.imapConfiguration?.user?.firstName + ' ' + this.imapConfiguration?.user?.emailAddress + ' ' + this.imapConfiguration?.user?.userId;
        this.selectedUser = this.imapConfiguration.user;
        this.onUserSeleted(this.selectedUser);
      }
      this.form1.patchValue(this.imapConfiguration);
		} else {
			//this.form1.patchValue({ userId: this.currentUser.userId });
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.imapConfigurationId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete();
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.imapConfigurationService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.imapConfiguration = res.data.imapConfiguration;
						this.doAdd.emit(this.imapConfiguration);
					},
					(err: any) => {
						console.log('imapConfiguration-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

  testConnection() {
    try {
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      console.log('property-add post: ' + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.imapConfigurationService.testConnection(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log('property-add SUCCESS: ' + JSON.stringify(res));
            if ( res.message.indexOf('fail') > -1 ){
              this.alertService.error( res.message);
            }
            else {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            }
          },
          (err: any) => {
            console.log('imapConfiguration-Test FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error) {
      this.alertService.error(error);
    }
  }

  testGmailConnection() {
    try {
      this.gmailTestLoading = true;
      this.gmailTestResult = null;
      this.imapConfigurationService.testGmailConnection(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log('testGmailConnection SUCCESS: ' + JSON.stringify(res));
            this.gmailTestResult = res.data?.gmailTest;
            if (res.data?.gmailTest?.success) {
              this.messageService.add({ severity: 'success', summary: 'Gmail Connection OK', detail: res.message });
            } else {
              this.alertService.error(res.message);
            }
          },
          (err: any) => {
            console.log('testGmailConnection FAIL: ' + JSON.stringify(err));
            this.gmailTestResult = { success: false, error: err?.error?.message || 'Connection failed' };
            this.alertService.error(err);
          },
          () => { this.gmailTestLoading = false; });
    } catch (error) {
      this.alertService.error(error);
      this.gmailTestLoading = false;
    }
  }

  syncByGmailId() {
    try {
      if (!this.syncGmailMsgId || !this.imapConfigurationId) {
        this.alertService.error('Please enter a Gmail Message ID and save the configuration first.');
        return;
      }
      this.syncGmailLoading = true;
      this.syncGmailResult = null;
      this.imapConfigurationService.syncByGmailId(this.imapConfigurationId, this.syncGmailMsgId)
        .subscribe(
          (res: any) => {
            console.log('syncByGmailId SUCCESS: ' + JSON.stringify(res));
            this.syncGmailResult = res.data?.syncResult;
            this.messageService.add({ severity: 'success', summary: 'Sync Complete', detail: res.message });
          },
          (err: any) => {
            console.log('syncByGmailId FAIL: ' + JSON.stringify(err));
            this.syncGmailResult = { success: false, error: err?.error?.message || 'Sync failed' };
            this.alertService.error(err);
          },
          () => { this.syncGmailLoading = false; });
    } catch (error) {
      this.alertService.error(error);
      this.syncGmailLoading = false;
    }
  }

	formUpdate() {
		console.log('imapConfiguration: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.imapConfigurationService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.imapConfiguration = res.data.imapConfiguration;
						this.doUpdate.emit(this.imapConfiguration);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.imapConfigurationService.delete(this.imapConfiguration.imapConfigurationId)
				.subscribe(
					(res: any) => {
						console.log('imapConfiguration-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.imapConfiguration);
					},
					(err: any) => {
						console.log('imapConfiguration-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			imapConfigurationId: [this.imapConfigurationId],
			name: ['', Validators.required],
			email: ['', Validators.required],
			password: ['', Validators.required],
			protocol: ['imaps', Validators.required],
			host: ['imap.gmail.com', Validators.required],
			port: ['993', Validators.required],
			lastreaduid: ['0', Validators.required],
			lastsentreaduid: ['0', Validators.required],
			msgreadpercall: ['30', Validators.required],
      msgremainingToBeRead: [''],
			userId: [''],
			inboxFolder: ['Inbox', Validators.required],
			sentFolder: ['[Gmail]/Sent Mail'],
			access: [2],
			active: [true],
      smtpProtocol: ['SMTP', Validators.required],
      smtpHost: ['', Validators.required],
      smtpPort: ['', Validators.required],
      smtpSSLPort: ['', Validators.required],

      // Gmail API fields
      gmailSyncEnabled: [false],
      gmailAuthType: [0],
      gmailCredentials: [''],
      gmailHistoryId: [''],

      // Bulk sync progress (read-only)
      gmailBulkSyncStatus: [{value: '', disabled: true}],
      gmailBulkSyncTotalListed: [{value: 0, disabled: true}],
      gmailBulkSyncTotalProcessed: [{value: 0, disabled: true}],
      gmailBulkSyncStartedAt: [{value: '', disabled: true}],
      gmailBulkSyncLastActivityAt: [{value: '', disabled: true}],

		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.imapConfiguration.imapConfigurationDate = moment(this.imapConfiguration.imapConfigurationDate).toDate();
	}
  onKeyInput(event)
  {
    let query = event.query;
    this.findUsersWith(query);
    return this.users;
  }

  findUsersWith(queryString: string)
  {
    this.userService.findUsersWith(queryString).pipe(first()).subscribe(

      data =>
      {
        console.log('taskUser serach: ' + JSON.stringify(data));
        this.users = [];
        this.users = data.data.userSummaryList;
        this.users.forEach(user => {
          if ( !user.lastName) { user.lastName = ''; }
          if ( !user.firstName) { user.firstName = ''; }
          user.fullName = user.lastName + ' ' + user.firstName + ' ' + user.emailAddress + ' ' + user.userId;
        });
        // console.log('QA: ' + JSON.stringify(this.taskUserSuggestions));
      },
      error =>
      {
        // console.log('reports LIST!: ' + JSON.stringify(error));
        this.alertService.error(error);
      },
      () =>
      { }
    );
  }
  userInfo(event: any){
    this.userId = event;
  }

	onUserSeleted(user: any) {
		this.selectedUser = user;
		this.form1.patchValue({ userId: this.selectedUser.userId });
	}
}
